<template>
  <div class="form-docx-view" v-loading="loading" :element-loading-text="useOo ? '正在打开 Word…' : '正在生成预览…'">
    <div v-if="showToolbar" class="form-docx-view__toolbar">
      <el-select
        v-if="docxForms.length"
        :value="selectedFormKey"
        size="mini"
        filterable
        placeholder="选择表单"
        class="form-docx-view__select"
        @change="onFormChange"
      >
        <el-option
          v-for="f in docxForms"
          :key="f.instanceKey || f.num"
          :label="formOptionLabel(f)"
          :value="f.instanceKey || String(f.num)"
        />
      </el-select>
      <span v-if="toolbarTitle" class="form-docx-view__title">{{ toolbarTitle }}</span>
      <div class="form-docx-view__toolbar-actions">
        <el-button v-if="xmbh" type="text" size="mini" @click="goWorkspace">任务监控</el-button>
      </div>
    </div>
    <OnlyOfficeViewer v-if="useOo && ooConfig" :config="ooConfig" class="form-docx-view__oo" />
    <template v-else-if="pages.length">
      <div class="form-docx-view__pages">
        <div v-for="pg in pages" :key="pg.page" class="form-docx-view__page">
          <img :src="pg.url" :alt="'第' + pg.page + '页'" class="form-docx-view__img">
        </div>
      </div>
    </template>
    <div v-else-if="loadError" class="form-docx-view__error">
      <p>{{ loadError }}</p>
      <el-button size="small" @click="load">重试</el-button>
      <el-button v-if="!useOo" size="small" type="text" @click="openOnlyOffice">用 Word 在线打开</el-button>
    </div>
    <div v-else-if="!loading" class="form-docx-view__error">
      <p>预览未加载</p>
      <el-button size="small" @click="load">重试</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import OnlyOfficeViewer from '@/components/OnlyOfficeViewer.vue'
import { preloadOnlyOfficeApi } from '@/utils/onlyoffice'

export default {
  name: 'FormDocxView',
  components: { OnlyOfficeViewer },
  data() {
    return {
      loading: false,
      pages: [],
      loadError: '',
      ooConfig: null,
      useOo: false,
      previewCached: false,
      ooSwitching: false,
      ooConfigCache: null,
      ooPrefetchKey: '',
      projectForms: []
    }
  },
  computed: {
    xmbh() {
      return String(this.$route.query.xmbh || '')
    },
    formNum() {
      const raw = String(this.$route.query.form_num || this.$route.query.form || '')
      const m = raw.match(/^(\d+)-1$/)
      return m ? m[1] : raw.replace(/\D/g, '')
    },
    ntrId() {
      return parseInt(String(this.$route.query.ntr_id || '0'), 10) || 0
    },
    cyrq() {
      return String(this.$route.query.cyrq || '').trim()
    },
    scope() {
      return this.$route.query.scope === 'sample' ? 'sample' : 'batch'
    },
    docxForms() {
      return (this.projectForms || []).filter(f => {
        const url = String((f && f.actionUrl) || '')
        return url.indexOf('/forms/docx') === 0 || url.indexOf('/forms?') === 0
      })
    },
    showToolbar() {
      return this.docxForms.length > 0
    },
    selectedFormKey() {
      if (String(this.formNum) === '135' && this.ntrId > 0) {
        return '135-' + this.ntrId
      }
      if (this.cyrq) {
        const key = this.formNum + '-' + this.cyrq
        const hitByKey = (this.projectForms || []).find(f => String(f.instanceKey || '') === key)
        if (hitByKey) return key
      }
      const hit = (this.projectForms || []).find(f => {
        if (String(f.num) !== String(this.formNum)) return false
        if (String(this.formNum) === '135' && f.bdslId) {
          return Number(f.bdslId) === this.ntrId
        }
        if (this.cyrq) {
          return String(f.cyrq || '') === this.cyrq
        }
        return !f.cyrq
      })
      return (hit && hit.instanceKey) || String(this.formNum)
    },
    toolbarTitle() {
      const hit = (this.projectForms || []).find(f => String(f.instanceKey || f.num) === String(this.selectedFormKey))
        || (this.projectForms || []).find(f => String(f.num) === String(this.formNum))
      if (!hit) return ''
      return hit.title || ''
    }
  },
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        if (this.xmbh) this.loadProjectForms()
        this.bootstrap()
      }
    }
  },
  mounted() {
    preloadOnlyOfficeApi()
    this.loadProjectForms()
    this.bootstrap()
  },
  methods: {
    formOptionLabel(f) {
      const num = String((f && f.num) || '')
      const title = String((f && f.title) || '')
      return title ? `${num} ${title}` : num
    },
    async loadProjectForms() {
      if (!this.xmbh) {
        this.projectForms = []
        return
      }
      try {
        const res = await api.get('yn_project_workspace', { xmbh: this.xmbh })
        const d = res.data || {}
        this.projectForms = Array.isArray(d.forms) ? d.forms : []
      } catch (e) {
        this.projectForms = []
      }
    },
    onFormChange(key) {
      const hit = (this.projectForms || []).find(f => String(f.instanceKey || f.num) === String(key))
        || (this.projectForms || []).find(f => String(f.num) === String(key))
      if (!hit || !hit.actionUrl) return
      this.navigateActionUrl(hit.actionUrl)
    },
    navigateActionUrl(url) {
      const r = String(url || '')
      const qi = r.indexOf('?')
      if (qi >= 0) {
        const path = r.slice(0, qi)
        const query = {}
        r.slice(qi + 1).split('&').forEach(pair => {
          if (!pair) return
          const eq = pair.indexOf('=')
          const k = eq >= 0 ? pair.slice(0, eq) : pair
          const v = eq >= 0 ? decodeURIComponent(pair.slice(eq + 1)) : ''
          query[k] = v
        })
        this.$router.push({ path, query }).catch(() => {})
      } else if (r) {
        this.$router.push(r).catch(() => {})
      }
    },
    goWorkspace() {
      if (!this.xmbh) return
      this.$router.push({ path: '/task-track', query: { xmbh: this.xmbh } }).catch(() => {})
    },
    bootstrap() {
      this.ooConfigCache = null
      this.ooPrefetchKey = ''
      const wantOo = String(this.$route.query.oo || '') === '1'
      // 135 任务派遣单：固定 PNG 预览（忽略历史链接里的 oo=1）
      if (String(this.formNum) === '135') {
        this.useOo = false
        this.ooConfig = null
        if (wantOo) {
          const q = { ...this.$route.query }
          delete q.oo
          this.$router.replace({ path: this.$route.path, query: q }).catch(() => {})
          return
        }
        this.loadPngPreview()
        return
      }
      if (wantOo) {
        this.useOo = true
        this.loadOnlyOffice()
      } else {
        this.useOo = false
        this.loadPngPreview()
      }
    },
    ooQueryKey() {
      return [this.xmbh, this.formNum, this.scope, this.ntrId || 0, this.cyrq || ''].join('|')
    },
    prefetchOoConfig() {
      // 135 不预取 OnlyOffice
      if (String(this.formNum) === '135') return
      const key = this.ooQueryKey()
      if (!this.xmbh || !this.formNum || this.ooPrefetchKey === key) return
      this.ooPrefetchKey = key
      const params = {
        xmbh: this.xmbh,
        form_num: this.formNum,
        scope: this.scope,
        ntr_id: this.ntrId || undefined
      }
      if (this.cyrq) params.cyrq = this.cyrq
      api.get('yn_tr_lab_oo_view', params).then(res => {
        const payload = res.data || {}
        if (!payload.error && payload.document && payload.document.url) {
          this.ooConfigCache = payload
        }
      }).catch(() => {})
    },
    openOnlyOffice() {
      if (String(this.formNum) === '135') {
        this.$message.info('135 派遣单已改为图片预览')
        return
      }
      this.ooSwitching = true
      preloadOnlyOfficeApi().finally(() => {
        this.ooSwitching = false
        this.$router.replace({
          path: '/forms/docx',
          query: { ...this.$route.query, oo: '1' }
        }).catch(() => {})
      })
    },
    async load() {
      if (this.useOo) this.loadOnlyOffice()
      else this.loadPngPreview()
    },
    async loadPngPreview() {
      if (!this.xmbh || !this.formNum) {
        this.loadError = '缺少项目编号或表号'
        this.pages = []
        return
      }
      this.loading = true
      this.loadError = ''
      this.pages = []
      try {
        const params = {
          xmbh: this.xmbh,
          form_num: this.formNum,
          scope: this.scope,
          // 现场/水质表：安排或 App 灌数后易脏缓存，强制按最新 docx 重转
          force: ['072', '074', '054', '055', '053', '058', '059', '060', '135', '136', '158', '185'].indexOf(String(this.formNum)) >= 0 ? 1 : 0
        }
        if (this.ntrId > 0) params.ntr_id = this.ntrId
        if (this.cyrq) params.cyrq = this.cyrq
        const res = await api.get('yn_tr_lab_docx_preview', params)
        const d = res.data || {}
        if (d.error) {
          this.loadError = d.error
          return
        }
        const pages = (d.pages || []).filter(p => p && p.url)
        if (!pages.length) {
          this.loadError = '未生成预览图'
          return
        }
        this.pages = pages
        this.previewCached = !!d.cached
        document.title = `GSYN-${this.formNum}`
        this.prefetchOoConfig()
      } catch (e) {
        this.loadError = (e && e.message) || '加载预览失败'
      } finally {
        this.loading = false
      }
    },
    async loadOnlyOffice() {
      if (!this.xmbh || !this.formNum) {
        this.loadError = '缺少项目编号或表号'
        return
      }
      const cacheKey = this.ooQueryKey()
      if (this.ooConfigCache && this.ooPrefetchKey === cacheKey) {
        this.ooConfig = this.ooConfigCache
        this.loadError = ''
        this.loading = false
        document.title = (this.ooConfig.document && this.ooConfig.document.title) || `GSYN-${this.formNum}`
        return
      }
      this.loading = true
      this.loadError = ''
      this.ooConfig = null
      try {
        const ooParams = {
          xmbh: this.xmbh,
          form_num: this.formNum,
          scope: this.scope
        }
        if (this.ntrId > 0) ooParams.ntr_id = this.ntrId
        if (this.cyrq) ooParams.cyrq = this.cyrq
        const res = await api.get('yn_tr_lab_oo_view', ooParams)
        const payload = res.data || {}
        if (payload.error) {
          this.loadError = payload.error
          return
        }
        if (!payload.document || !payload.document.url) {
          this.loadError = '表单预览加载失败'
          return
        }
        this.ooConfig = payload
        this.ooConfigCache = payload
        this.ooPrefetchKey = cacheKey
        document.title = payload.document.title || `GSYN-${this.formNum}`
      } catch (e) {
        this.loadError = (e && e.message) || '加载表单失败'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.form-docx-view {
  min-height: 400px;
  background: #eef0f3;
  padding: 12px 16px 40px;
}
.form-docx-view__toolbar {
  max-width: min(1123px, 100%);
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 8px 12px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.form-docx-view__select {
  width: 280px;
}
.form-docx-view__title {
  flex: 1;
  min-width: 120px;
  font-size: 13px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.form-docx-view__toolbar-actions {
  margin-left: auto;
}
.form-docx-view__pages {
  /* A4 横版约 297mm，预览按满纸宽度展示 */
  max-width: min(1123px, 100%);
  margin: 0 auto;
}
.form-docx-view__page {
  margin-bottom: 16px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 2px;
  overflow: hidden;
}
.form-docx-view__img {
  display: block;
  width: 100%;
  height: auto;
}
.form-docx-view__error {
  padding: 48px 24px;
  text-align: center;
  color: #909399;
}
.form-docx-view__oo {
  height: calc(100vh - 120px);
  min-height: 480px;
}
</style>
